import React from "react";
import "./table-header.styles.scss";

const selectHeaders = (pageIdentifier,labels) => {
  switch (pageIdentifier) {
    case "project":
      return [
        { colName: `${labels?.ProjectSingular ?? "PROJECT"} NAME`, colType: "th-project-col" },
        { colName: "PRIORITY", colType: "th-priority-col" },
        { colName: "STATUS", colType: "th-status-col" },
        { colName: `${labels?.TaskPlural ?? "TASKS"}`, colType: "th-tasks-col" },
        { colName: "TAGS", colType: "th-tags-col" },
        { colName: "MEMBERS", colType: "th-members-col" },
        { colName: "START DATE", colType: "th-date-col" },
        { colName: "DUE DATE", colType: "th-date-col" },
      ];
    case "task":
      return [
        { colName: "", colType: "th-checkbox-col" },
        { colName: "", colType: "th-checkbox-col" },
        { colName: "TYPE", colType: "th-task-type-col" },
        { colName: `${labels?.TaskSingular ?? "TASK"} NAME`, colType: "th-project-col" },
        { colName: `${labels?.ProjectSingular ?? "PROJECT"}`, colType: "th-project-col" },
        { colName: "PRIORITY", colType: "th-priority-col" },
        { colName: "TASK STATUS", colType: "th-status-col" },
        { colName: "LAST ACTIVITY", colType: "th-date-col" },
        { colName: "PERMISSION", colType: "th-permission-col" },
        { colName: "MEMBERS", colType: "th-members-col" },
        { colName: "DUE DATE", colType: "th-date-col" },
      ];
    default:
      return;
  }
};

const TableHeader = ({ pageIdentifier, labels }) => {
  // Select headers to render based on pageIdentifier
  const headers = selectHeaders(pageIdentifier, labels);

  return (
    <thead className="table-header-row">
      <tr className={pageIdentifier}>
        <th className="th-tab-indicator-col"></th>
        <th className="th-checkbox-col"></th>

        {headers &&
          headers.map((header, index) => {
            return (
              <th key={index} className={header.colType}>
                <div className="th-container">
                    <div className="th-name">{header.colName}</div>
                </div>
              </th>
            );
          })}
        <th className="th-actions-col">
          <div className="th-name">ACTIONS</div>
        </th>
      </tr>
    </thead>
  );
};

export default TableHeader;
